import axios from "axios";

/**
 * Same-origin API client.
 * - baseURL is relative so no CORS preflight.
 * - withCredentials ensures the cd_session cookie is sent on every request.
 */
const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export default api;
